export const News = {
  Latest: {
    Data: {}
  }
}
